import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type {
  onCopyTaskArgs,
  onCopyTaskCallback,
  onTaskDeletedCallback,
  onTaskSaveErrorCallback,
  onTaskSavedCallback,
  onTaskSavingCallback,
} from 'donor-elf-web/components/task/info';
import { JOURNAL_COPY_AND_PASTE_ALL_CONFIRMATION } from 'donor-elf-web/controllers/funds/fund/journals/journal/index';
import V2TaskModel from 'donor-elf-web/models/v2-task';

interface ComponentArgs {
  task: V2TaskModel;
  errorSavingTask: boolean;
  showAssignedUsersIfPresent: boolean;
  onCopyTask: onCopyTaskCallback;
  onTaskSaving: onTaskSavingCallback;
  onTaskSaveError: onTaskSaveErrorCallback;
  onTaskSaved: onTaskSavedCallback;
  onTaskDeleted: onTaskDeletedCallback;
}

export default class JournalCellStageTaskComponent extends Component<ComponentArgs> {
  @tracked standinTrigger = true;

  copyAndPasteAllConfirmation = JOURNAL_COPY_AND_PASTE_ALL_CONFIRMATION;

  @action
  removeStandinTrigger() {
    this.standinTrigger = false;
  }

  @action
  handleCopyTask(dropdown: any, copyArgs: onCopyTaskArgs) {
    if (copyArgs.pasteAll) {
      dropdown.actions.close();
    }
    this.args.onCopyTask(copyArgs);
  }
}
